import { useEffect } from "react";

// sets the dropdown based on the data
// the tblName and tblColumn are used if its from the types table and if there is
// an excluded value use the alternate field and colExclusion to specify
// if it's a different tbl it uses the alternate field for the label
export const useGetOptions = (
  setDD,
  data,
  tblName,
  tblColumn,
  alternateField,
  colExclusion,
  activeStatus
) => {
  useEffect(() => {
    const arr = [];
    if (alternateField === 'fsc_name') {
      arr.push({value: 0, label: 'Use Mileage'})
    }
    if (data) {
      if (!data.error) {
        if (tblName && tblColumn) {
          data.forEach((d) => {
            if (d.name_of_tbl === tblName && d.tbl_column === tblColumn) {
              if (colExclusion && alternateField) {
                if (d[alternateField] !== colExclusion) {
                  arr.push({ value: d.id, label: d.type_name });
                }
              } else {
                arr.push({ value: d.id, label: d.type_name });
              }
            }
          });
        } else if (alternateField && data) {
          // console.log(data)
          if (!data.error) {
            if (activeStatus) {
              data.forEach((d) => {
                if (d.is_active) {
                  arr.push({ value: d.id, label: d[alternateField] });
                }
              });
            } else {
              data.forEach((d) => {
                arr.push({ value: d.id, label: d[alternateField] });
              });
            }
          }
        }
      }
      setDD(arr);
    }
  }, [data, tblName, tblColumn, alternateField, colExclusion, setDD, activeStatus]);
};
